import { createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Download Times")
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "form-check mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, " use default ", -1)
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { class: "input-group mb-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, "Time", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  "data-bs-dismiss": "modal",
  class: "btn btn-outline-dark"
}, " Cancel ", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Disable Download Times")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h4", null, "Do you want to disable the download times for players?", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  "data-bs-dismiss": "modal",
  class: "btn btn-outline-dark"
}, " Cancel ", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Reboot the players ")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h4", null, "Do you want to reboot the player?", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  "data-bs-dismiss": "modal",
  class: "btn btn-outline-dark"
}, " Cancel ", -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Upload log files for the players")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h4", null, "Do you want to make the players upload the recent logs?", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  "data-bs-dismiss": "modal",
  class: "btn btn-outline-dark"
}, " Cancel ", -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Take a snapshot ")
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h4", null, "Do you want to take a snaoshot of the players?", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  "data-bs-dismiss": "modal",
  class: "btn btn-outline-dark"
}, " Cancel ", -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Delete Player")
const _hoisted_23 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  "data-bs-dismiss": "modal",
  class: "btn btn-outline-dark"
}, " Cancel ", -1)
const _hoisted_24 = { class: "container-fluid players-page" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "col" }
const _hoisted_27 = { class: "card mb-2" }
const _hoisted_28 = { class: "card-body" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Brightsign players")
], -1)
const _hoisted_31 = { class: "col-3" }
const _hoisted_32 = { class: "form-check form-check-inline" }
const _hoisted_33 = {
  class: "form-check-label",
  for: "flexCheckDefault"
}
const _hoisted_34 = { class: "form-check form-check-inline" }
const _hoisted_35 = {
  class: "form-check-label",
  for: "flexCheckChecked"
}
const _hoisted_36 = { class: "form-check form-check-inline" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckDefault"
}, " Disabled DT ", -1)
const _hoisted_38 = {
  key: 0,
  class: "btn-group btn-group-sm",
  role: "group"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-outline-dark",
  "data-bs-toggle": "modal",
  "data-bs-target": "#downloadTimesDisableModal"
}, " Disable DT ", -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-outline-dark",
  "data-bs-toggle": "modal",
  "data-bs-target": "#takeSnapshotModal"
}, " Snapshot ", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-outline-dark",
  "data-bs-toggle": "modal",
  "data-bs-target": "#getLogsPlayersModal"
}, " Logs ", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-outline-dark",
  "data-bs-toggle": "modal",
  "data-bs-target": "#rebootPlayersModal"
}, " Reboot ", -1)
const _hoisted_43 = { class: "offset-3 col-3" }
const _hoisted_44 = { class: "input-group mb-1 mt-1" }
const _hoisted_45 = { class: "col" }
const _hoisted_46 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-card-list" }, null, -1)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-grid-3x3-gap" }, null, -1)
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("a", {
  class: "btn btn-light",
  "data-bs-toggle": "collapse",
  href: "#filterCollapse",
  role: "button",
  "aria-expanded": "false",
  "aria-controls": "filterCollapse"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-filter" })
], -1)
const _hoisted_52 = { class: "row" }
const _hoisted_53 = { class: "col-12" }
const _hoisted_54 = {
  class: "collapse mb-2",
  id: "filterCollapse"
}
const _hoisted_55 = { class: "card card-body" }
const _hoisted_56 = { class: "row mt-1" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword",
  class: "col-1 col-form-label"
}, "Group", -1)
const _hoisted_58 = { class: "col-3" }
const _hoisted_59 = { class: "row mt-1" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword",
  class: "col-1 col-form-label"
}, "Presentation", -1)
const _hoisted_61 = { class: "col-3" }
const _hoisted_62 = { class: "row mt-1" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", {
  for: "inputPassword",
  class: "col-1 col-form-label"
}, "Prime player", -1)
const _hoisted_64 = { class: "col-3" }
const _hoisted_65 = {
  key: 0,
  class: "row"
}
const _hoisted_66 = { class: "col-12" }
const _hoisted_67 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_68 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-images" }, null, -1)
const _hoisted_69 = ["onClick"]
const _hoisted_70 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-bootstrap-reboot" }, null, -1)
const _hoisted_71 = [
  _hoisted_70
]
const _hoisted_72 = ["onClick"]
const _hoisted_73 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1)
const _hoisted_74 = [
  _hoisted_73
]
const _hoisted_75 = {
  key: 1,
  class: "row tile-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_modal_component = _resolveComponent("modal-component")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_popover = _resolveComponent("popover")!
  const _component_table_lite = _resolveComponent("table-lite")!
  const _component_player_tile = _resolveComponent("player-tile")!
  const _directive_role = _resolveDirective("role")!
  const _directive_debounce = _resolveDirective("debounce")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_modal_component, {
      id: "downloadTimesEnableModal",
      onOnClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.resetComponentState()))
    }, {
      header: _withCtx(() => [
        _hoisted_1
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.downloadTimesDefault) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.downloadTimesDefault]
              ]),
              _hoisted_5
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_Datepicker, {
                disabled: _ctx.downloadTimesDefault,
                modelValue: _ctx.downloadTimes,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.downloadTimes) = $event)),
                minutesIncrement: "5",
                timePicker: "",
                disableTimeRangeValidation: "",
                range: "",
                placeholder: "Select Time"
              }, null, 8, ["disabled", "modelValue"])
            ])
          ])
        ])
      ]),
      footer: _withCtx(() => [
        _hoisted_9,
        _createElementVNode("button", {
          type: "button",
          "data-bs-dismiss": "modal",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.enableDownloadTimes && _ctx.enableDownloadTimes(...args))),
          class: "btn btn-outline-dark"
        }, " Enable ")
      ]),
      _: 1
    }),
    _createVNode(_component_modal_component, {
      id: "downloadTimesDisableModal",
      onOnClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.resetComponentState()))
    }, {
      header: _withCtx(() => [
        _hoisted_10
      ]),
      body: _withCtx(() => [
        _hoisted_11
      ]),
      footer: _withCtx(() => [
        _hoisted_12,
        _createElementVNode("button", {
          type: "button",
          "data-bs-dismiss": "modal",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.disableDownloadTimes && _ctx.disableDownloadTimes(...args))),
          class: "btn btn-outline-dark"
        }, " Disable ")
      ]),
      _: 1
    }),
    _createVNode(_component_modal_component, {
      id: "rebootPlayersModal",
      onOnClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.resetComponentState()))
    }, {
      header: _withCtx(() => [
        _hoisted_13
      ]),
      body: _withCtx(() => [
        _hoisted_14
      ]),
      footer: _withCtx(() => [
        _hoisted_15,
        _createElementVNode("button", {
          type: "button",
          "data-bs-dismiss": "modal",
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.rebootPlayers && _ctx.rebootPlayers(...args))),
          class: "btn btn-outline-dark"
        }, " Reboot ")
      ]),
      _: 1
    }),
    _createVNode(_component_modal_component, {
      id: "getLogsPlayersModal",
      onOnClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.resetComponentState()))
    }, {
      header: _withCtx(() => [
        _hoisted_16
      ]),
      body: _withCtx(() => [
        _hoisted_17
      ]),
      footer: _withCtx(() => [
        _hoisted_18,
        _createElementVNode("button", {
          type: "button",
          "data-bs-dismiss": "modal",
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.getLogs && _ctx.getLogs(...args))),
          class: "btn btn-outline-dark"
        }, " Yes ")
      ]),
      _: 1
    }),
    _createVNode(_component_modal_component, {
      id: "takeSnapshotModal",
      onOnClose: _cache[11] || (_cache[11] = ($event: any) => (_ctx.resetComponentState()))
    }, {
      header: _withCtx(() => [
        _hoisted_19
      ]),
      body: _withCtx(() => [
        _hoisted_20
      ]),
      footer: _withCtx(() => [
        _hoisted_21,
        _createElementVNode("button", {
          type: "button",
          "data-bs-dismiss": "modal",
          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.takeSnapshot && _ctx.takeSnapshot(...args))),
          class: "btn btn-outline-dark"
        }, " Yes ")
      ]),
      _: 1
    }),
    _createVNode(_component_modal_component, {
      id: "deletePlayerModal",
      onOnClose: _cache[13] || (_cache[13] = ($event: any) => (_ctx.resetComponentState()))
    }, {
      header: _withCtx(() => [
        _hoisted_22
      ]),
      body: _withCtx(() => [
        _createElementVNode("h4", null, "Do you want to delete the player \"" + _toDisplayString(_ctx.selected?.Name) + "\"?", 1)
      ]),
      footer: _withCtx(() => [
        _hoisted_23,
        _createElementVNode("button", {
          type: "button",
          "data-bs-dismiss": "modal",
          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.deletePlayer && _ctx.deletePlayer(...args))),
          class: "btn btn-outline-dark"
        }, " Delete ")
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.onlineFilterOn) = $event)),
                      onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.onStatusFilterChange && _ctx.onStatusFilterChange(...args))),
                      class: "form-check-input",
                      name: "status",
                      type: "checkbox",
                      id: "flexCheckDefault"
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.onlineFilterOn]
                    ]),
                    _createElementVNode("label", _hoisted_33, " Online (" + _toDisplayString(_ctx.online) + ") ", 1)
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.offlineFilterOn) = $event)),
                      onChange: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.onStatusFilterChange && _ctx.onStatusFilterChange(...args))),
                      class: "form-check-input",
                      name: "status",
                      type: "checkbox",
                      id: "flexCheckChecked",
                      checked: ""
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.offlineFilterOn]
                    ]),
                    _createElementVNode("label", _hoisted_35, " Offline (" + _toDisplayString(_ctx.offline) + ") ", 1)
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.dtFileterOn) = $event)),
                      onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.onDtFilterChange && _ctx.onDtFilterChange(...args))),
                      class: "form-check-input",
                      name: "status",
                      type: "checkbox",
                      id: "flexCheckDefault"
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.dtFileterOn]
                    ]),
                    _hoisted_37
                  ]),
                  (_ctx.filtersUsed)
                    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _hoisted_39,
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-outline-dark",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#downloadTimesEnableModal",
                          onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.onDTModalOpen(_ctx.downloadTimes)))
                        }, " Enable DT "),
                        _hoisted_40,
                        _hoisted_41,
                        _hoisted_42
                      ])), [
                        [_directive_role, void 0, "admin"]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.searchString) = $event)),
                      type: "test",
                      class: "form-control",
                      placeholder: "Search"
                    }, null, 512), [
                      [_vModelText, _ctx.searchString],
                      [_directive_debounce, _ctx.onSearch, "300ms"]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-light",
                      onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.switchView(_ctx.modes.LIST)))
                    }, _hoisted_48),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-light",
                      onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.switchView(_ctx.modes.GRID)))
                    }, _hoisted_50),
                    _hoisted_51
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _hoisted_57,
                _createElementVNode("div", _hoisted_58, [
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.groupId,
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.groupId) = $event)),
                    options: _ctx.playerGroups,
                    reduce: (group) => group.Id,
                    label: "Name",
                    taggable: "",
                    multiple: "",
                    disabled: !_ctx.groupFilterEnabled,
                    "onOption:deselected": _ctx.onFilterByGroup,
                    "onOption:selected": _ctx.onFilterByGroup
                  }, null, 8, ["modelValue", "options", "reduce", "disabled", "onOption:deselected", "onOption:selected"])
                ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                _hoisted_60,
                _createElementVNode("div", _hoisted_61, [
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.presentationName,
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.presentationName) = $event)),
                    options: _ctx.playerPresentations,
                    reduce: (presentation) => presentation.Name,
                    label: "Name",
                    taggable: "",
                    multiple: "",
                    disabled: !_ctx.presentationFIlterEnabled,
                    "onOption:deselected": _ctx.onFilterByPresenation,
                    "onOption:selected": _ctx.onFilterByPresenation
                  }, null, 8, ["modelValue", "options", "reduce", "disabled", "onOption:deselected", "onOption:selected"])
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _hoisted_63,
                _createElementVNode("div", _hoisted_64, [
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.primePlayerId,
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.primePlayerId) = $event)),
                    options: _ctx.primePlayers,
                    reduce: (player) => player.id,
                    label: "Name",
                    taggable: "",
                    multiple: "",
                    disabled: !_ctx.primePlayerFilterEnabled,
                    "onOption:deselected": _ctx.onFilterByPrimePlayer,
                    "onOption:selected": _ctx.onFilterByPrimePlayer
                  }, null, 8, ["modelValue", "options", "reduce", "disabled", "onOption:deselected", "onOption:selected"])
                ])
              ])
            ])
          ])
        ])
      ]),
      (_ctx.viewMode == _ctx.modes.LIST)
        ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
            _createElementVNode("div", _hoisted_66, [
              _createVNode(_component_table_lite, {
                "is-slot-mode": true,
                columns: _ctx.table.columns,
                "is-static-mode": true,
                "is-re-search": true,
                "page-size": _ctx.perPage,
                rows: _ctx.items,
                total: _ctx.items.length,
                pageOptions: [],
                messages: {
              pagingInfo: '',
              pageSizeChangeLabel: '',
              gotoPageLabel: '',
              noDataAvailable: 'No data',
            }
              }, {
                name: _withCtx((data) => [
                  _createVNode(_component_router_link, {
                    to: {
                  name: 'PlayerInnerPage',
                  params: { id: data.value.id },
                }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(data.value.Name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                group: _withCtx((data) => [
                  _createTextVNode(_toDisplayString(data.value.ReportedGroup?.Name), 1)
                ]),
                presentation: _withCtx((data) => [
                  _createTextVNode(_toDisplayString(data.value.Presentation?.Name), 1)
                ]),
                uptime: _withCtx((data) => [
                  _createTextVNode(_toDisplayString(data.value.Uptime), 1)
                ]),
                PrimePlayerName: _withCtx((data) => [
                  (data.value.PrimePlayerId)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: {
                  name: 'PlayerInnerPage',
                  params: { id: data.value.PrimePlayerId },
                }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(data.value.PrimePlayerName), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    : _createCommentVNode("", true)
                ]),
                actions: _withCtx((data) => [
                  _createElementVNode("div", _hoisted_67, [
                    _createVNode(_component_popover, {
                      trigger: "hover",
                      content: "Screenshots",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: {
                    name: 'PlayerScreenshotsPage',
                    params: { id: data.value.id },
                  },
                          class: "btn btn-light"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_68
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_popover, {
                      trigger: "hover",
                      content: "Reboot",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#rebootPlayersModal",
                          onClick: ($event: any) => (_ctx.onSelect(data.value.id)),
                          class: "btn btn-light"
                        }, _hoisted_71, 8, _hoisted_69)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_popover, {
                      trigger: "hover",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          type: "button",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#deletePlayerModal",
                          onClick: ($event: any) => (_ctx.onSelect(data.value.id)),
                          class: "btn btn-light"
                        }, _hoisted_74, 8, _hoisted_72)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ]),
                _: 1
              }, 8, ["columns", "page-size", "rows", "total"])
            ])
          ]))
        : (_ctx.viewMode == _ctx.modes.GRID)
          ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-2 mb-3",
                  key: idx
                }, [
                  _createVNode(_component_player_tile, {
                    item: item,
                    loading: _ctx.playersProcessing.indexOf(item.id) >= 0
                  }, null, 8, ["item", "loading"])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
    ])
  ], 64))
}